import React, {useContext} from 'react';

import {
  Backdrop,
  SvgIcon,
} from '@mui/material';
import Box from '@mui/material/Box';
import {useTranslation} from 'react-i18next';

import CancellationContext from './CancellationContext';
import CancelFormContent from './CancellationFormContent';
import CancellationResult from './CancellationResult';
import {VIEW_STATE} from './Cancellations';
import {
  CancellationsContainer,
  EventContainer,
  EventStack,
  MainContainer,
  MainContainerContent,
  NavButton,
} from './Style';

import PoweredBy from '../PoweredBy';

import {ReactComponent as ChevronLeftFilled} from 'assets/svg/chevron-left-filled.svg';
import ApptCard from 'Components/ApptCard';
import MessageDisplay from 'Components/MessageDisplay';
import ErrorDisplay from 'Components/MessageDisplay/ErrorDisplay';
import PolicyTerms from 'Components/PolicyTerms';
import ZmSpinner from 'Components/ZmSpinner';
import {
  getEventEndTime,
} from 'Utils/apptAvailabilityUtils';


/**
 * Cancellations Page Component for Mobile Devices
 * @param {Object} props
 * @return {ReactElement}
 */
export default function CancellationMobile(props) {
  // Optionally pass in props from parsing b64
  // const {
  //   appointmentId,
  //   calendarId,
  // } = props;
  const {
    attendeeId,
    cancelResultType,
    currView,
    errorInfo,
    eventInfo,
    handleBack,
    isLoaded,
    onCancel,
    onReschedule,
    setCurrView,
    timeZone,
  } = useContext(CancellationContext);
  const {t} = useTranslation();

  const isCciAccount = eventInfo?.isCciEvent;

  const isEventExpired = getEventEndTime(eventInfo) < new Date();

  return (
    <EventContainer>
      {[VIEW_STATE.SLOT_VIEW,
        VIEW_STATE.FORM_VIEW].includes(currView) && <NavButton
        aria-label="Previous Step"
        key="nav-prev-step"
        variant="outlined" size="medium" color="inherit"
        onClick={handleBack}
      >
        <SvgIcon fontSize="small" component={() => (<div><ChevronLeftFilled /></div>)} inheritViewBox />
      </NavButton>}
      {(!isLoaded || errorInfo.isError) ?
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: '100vw',
            height: '100%',
          }}
        >
          {(errorInfo.isError) ? (
            <ErrorDisplay errorInfo={errorInfo}/>
          ) :
            <ZmSpinner size="80" absolute />
          }
        </Box> :
        (isEventExpired) ?
        <MessageDisplay
          header={t('cancellation.cancelEventExpiredHeader')}
          body={t('cancellation.cancelEventExpiredMsg')}
          isCciAccount={isCciAccount}
          isExpired={true}
        /> :
        <>
          <Backdrop
            sx={{
              zIndex: (theme) => theme.zIndex.drawer + 1,
              position: 'absolute',
              backgroundColor: 'rgba(255, 255, 255, 0.6)',
            }}
            open={!isLoaded}
          >
            <ZmSpinner size="80" absolute />
          </Backdrop>

          <EventStack>
            <MainContainer>
              <MainContainerContent>
                {(cancelResultType) ?
                  <CancellationResult
                    eventInfo={eventInfo}
                    cancelResult={cancelResultType}
                  /> :
                  (currView === VIEW_STATE.HOME_VIEW) ?
                  <CancellationsContainer>
                    <ApptCard
                      eventInfo={eventInfo}
                      timeZone={timeZone}
                      displayName={eventInfo?.hostDisplayName}
                      guests={eventInfo?.guests}
                      onCancel={onCancel}
                      onReschedule={onReschedule}
                      showAutoRefundPolicy={true}
                    />
                  </CancellationsContainer> :
                  <CancelFormContent
                    attendeeId={attendeeId}
                    eventInfo={eventInfo}
                    onSuccess={() => setCurrView(VIEW_STATE.CONFIRM_VIEW)}
                    onBackCancel={() => setCurrView(VIEW_STATE.HOME_VIEW)}
                  />
                }
              </MainContainerContent>
            </MainContainer>
            {!isCciAccount && <PoweredBy />}
            <PolicyTerms />
          </EventStack>
        </>
      }
    </EventContainer>
  );
}
